import { Badge } from '@shared/components';
import { AgreementStatusBadge } from '@features/agreements';
import type { DashboardItem } from '../../types/dashboard.types';
import { resolveStatusPresentation } from '../../utils/dashboardStatus';
import { isThirdPartyRow } from '../../utils/thirdPartyAgreements';

interface Props {
    row: DashboardItem;
}

export function StatusCell({ row }: Props) {
    const presentation = resolveStatusPresentation(row.status);
    if (presentation) return <Badge variant={presentation.variant}>{presentation.label}</Badge>;
    if (row.status && row.record_type === 'plan' && !isThirdPartyRow(row)) {
        return <AgreementStatusBadge status={row.status} />;
    }
    return <span className="capitalize text-sm">{row.status}</span>;
}
